import React from "react";
import { invariant } from "ts-invariant";
import { AnchorButton } from "../../components/common/Button";
import { GlobalNavVariation } from "../../constants/constants";
import { getVariationLabel } from "../../constants/strings";
import { DEMO_URL } from "../../constants/urls";
import { useCrossModalContext } from "../../hooks/useCrossModalContext";

export const getVariationTitle = (variation: GlobalNavVariation) => {
  switch (variation) {
    case GlobalNavVariation.RECRUIT:
      return "Ready to speed up your hiring process?";
    case GlobalNavVariation.HCP_TRAINING:
      return "Ready to empower your staff and make training fun?";
    case GlobalNavVariation.PINNACLE_RETAIN:
      return "Ready to reduce your turnover?";
    default:
      return "Want to gain access?";
  }
};

export const getVariationSubtitle = (
  variation: GlobalNavVariation,
  label: string
): string => {
  switch (variation) {
    case GlobalNavVariation.RECRUIT:
      return "Talk to an expert to see how Recruit can help you win the recruitment race.";
    case GlobalNavVariation.HCP_TRAINING:
      return "Talk to an expert today to learn more about how Training can help you grow and retain your staff.";
    case GlobalNavVariation.PINNACLE_RETAIN:
      return "Talk to an expert on how Retain can help you drive engagement and catch disengagement sooner.";
    default:
      return `Meet with a product expert to learn more about ${label}`;
  }
};

export const getVariationButton = (variation: GlobalNavVariation) => {
  switch (variation) {
    case GlobalNavVariation.RECRUIT:
      return "Request a demo";
    case GlobalNavVariation.HCP_TRAINING:
      return "Request a demo";
    case GlobalNavVariation.PINNACLE_RETAIN:
      return "Speak with an Expert";
    default:
      return "Get a Live Demo";
  }
};

const getVariationVideoUrl = (variation: GlobalNavVariation): string | null => {
  switch (variation) {
    case GlobalNavVariation.HCP_TRAINING:
      return "https://player.vimeo.com/video/998789169";
    case GlobalNavVariation.PINNACLE_RETAIN:
      return "https://player.vimeo.com/video/998795167";
    default:
      return null;
  }
};

export function CrossModalDemo() {
  const { crossModalVariation } = useCrossModalContext();

  invariant(crossModalVariation);

  const videoUrl = getVariationVideoUrl(crossModalVariation);

  return (
    <div className="bg-gray-100 px-8 py-6 text-center hcp:bg-hcp-gray-200">
      <h3 className="font-bold">{getVariationTitle(crossModalVariation)}</h3>
      <p className="mb-4 text-gray-700">
        {getVariationSubtitle(
          crossModalVariation,
          getVariationLabel(crossModalVariation)
        )}
      </p>
      <AnchorButton href={DEMO_URL} target="_blank">
        {getVariationButton(crossModalVariation)}
      </AnchorButton>

      {videoUrl && (
        <div
          className="relative mt-6"
          style={{ paddingTop: "56.25%", marginTop: 20 }}
        >
          <iframe
            src={`${videoUrl}?badge=0&autopause=0&player_id=0&app_id=58479`}
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
            allowFullScreen
            title="Product Overview Video"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          ></iframe>
        </div>
      )}
    </div>
  );
}
